import axios from 'axios';
import { toast } from 'react-toastify';
import LocalizedStrings from 'react-localization';

  const strings = new LocalizedStrings({
    en:{
      notifyEpayBgPayment: "Succesfull payment request",
      notifyEpayBgCheckPayment: "Checking payment...",
      notifyEpayBgCheckPaymentDone: "Payment is done, thank you!",
      notifyOrderCreated: "Success! Your Order is submitted",
      notifyError: "Something went wrong!",
      notifyErrorDeclinedPayment: "The payment was DECLINED by your provider!",
    },
    bg: {
      notifyEpayBgPayment: "Успешна заявка за плащане",
      notifyEpayBgCheckPayment: "Плащането се проверява...",
      notifyEpayBgCheckPaymentDone: "Плащането е извършено, благодарим Ви!",
      notifyOrderCreated: "Успешно! Поръчкара е изпратена.",
      notifyError: "Нещо се обърка!",
      notifyErrorDeclinedPayment: "Плащането е отхвърлено от вашата банка!",
      
    }
  });

  const _setLanguage = (lang) => {
    //console.log(lang)
    strings.setLanguage(lang)
  }

  _setLanguage('bg');

//const notifyEpayBgGetUserInfo = () => toast.info("Succesfully get USER INFO");
//const notifyEpayBgGetIdForPayment = () => toast.info("Succesfully get ID for payment");
const notifyEpayBgPayment = () => toast.info(strings.notifyEpayBgPayment);
const notifyEpayBgCheckPayment = () => toast.info(strings.notifyEpayBgCheckPayment);
const notifyEpayBgCheckPaymentDone = () => toast.success(strings.notifyEpayBgCheckPaymentDone);
const notifyOrderCreated = () => toast.success(strings.notifyOrderCreated);
const notifyError = () => toast.error(strings.notifyError);
const notifyErrorDeclinedPayment = () => toast.error(strings.notifyErrorDeclinedPayment);

//const TIMEOUT = 100

/* 
    getOrdersByToken = userid => {
    axios.post("http://localhost:3001/api/getOrdersData", {
      "items.userid": "admin"
    })
    .then(orders => orders.json())
    .then(res => this.setState({ orders: res.orders }))
    ;
  };
  */

/* const request = async () => {
  const response = await fetch('http://139.59.205.81/inventories/');
  const json = await response.json();
  //console.log('json', json);
  return json;
} */

/** 
* Order schema
*/
/*
{
  "_id": "5e7b29c31c9d4400003f9d97", //order id - auto-generated
  "status": "PENDING", // pending, confirmed, completed, cancelled, rejected 
  // pending - order is created in database, you only have info for type of payment
  //confirmed - (when paid by card and is successful || if cash, no confirmed status )
  //completed - (when picked-up) double click button on app (B2B ne e qsno)
  //rejected - card transaction is rejected
  //cancelled - vendor can cancel order - when changing status to cancelled show mandatory text field for reason that does not allow you to submit without reason 
  //for cash payments that are not collected, have a policy 
  "payment_method": "cash", // one of cash, card, bank transfer
  "account_id": "5e53cef6461a990ce3c5b834", //id of person making the order
  "created_by": "Pepo", //name of person making the order - non-essential
  "user_contacts": "", // phone number of person making the order - non-essential
  "user_notes" : "notes by the user" 
  "cancellation_reason" : "order cancellation reason" // not mandatory
  //change inventory to inventories
  "inventory_id": "5e7a29638a57137be326ba9d",
  "vendor_id": "5e53cef6461a990ce3c5b834", // ot kogo poruchwash
  "quantity_ordered": 2, //subtract from inventory_id 
},
"created": {
  "$numberInt": "1585087069"
},
"__v": {
  "$numberInt": "0"
}
*/

/* const productsVendors = (products) => {
  let vendors = [];
  Object.values(products).map(
    product => {
      vendors.push(product.account_id);
    }
  );
  console.log('vendors: ',vendors.toString());
  return vendors.toString();
}; */

const cartQuantities = (cart) => {
  let quantities = [];
  Object.entries(cart.quantityById).map(
    (item, i) => {
      quantities.push({
        'inventory_id': item[0],
        'quantity': item[1].quantity,
        'product_name': item[1].product_name,
        'item_price': item[1].item_price,
        'exp_date': item[1].exp_date,
        'place_name': item[1].place_name,
        'place_id': item[1].place_id
      });
      console.log('item:', item)
      console.log('item[0]:', item[0])
      console.log('item[1].place_name:', item[1].place_name)
    }
  );
  console.log('quantities: ',quantities);
  return quantities;
};

/* EPAYBG FUNCTIONS */
/* const EpayBGgetUserInfo = async(APPID, DEVICEID, TOKEN) => {
  //console.log(APPID, DEVICEID, CODE)
  //PINS=1 => If you want information about the Payment Instruments
  let validators;
  try {
    validators = await Promise.all([
      axios.get(`https://demo.epay.bg/xdev/api/user/info?APPID=${APPID}&DEVICEID=${DEVICEID}&TOKEN=${TOKEN}&PINS=1`)
    ]);

    return validators = validators.map(validator => {
      //console.log("EpayBGgetUserInfo", validator.data.payment_instruments[0])
      notifyEpayBgGetUserInfo();
      return validator.data.payment_instruments[0];
    });

  } catch (error) {
    console.log(error);
    notifyError();
  }
} */


/* const EpayBGgetIDforPayment = async(APPID, DEVICEID, TOKEN) => {
  let validators;
  try {
    validators = await Promise.all([
      axios.post('https://demo.epay.bg/xdev/api/payment/init', {
        TYPE: 'send',
        APPID: APPID,
        DEVICEID: DEVICEID,
        TOKEN: TOKEN
      })
      //.then(res => res.status === 200 ? notifyEpayBgGetIdForPayment() : notifyError())
    ]);

    return validators = validators.map(validator => {
      //console.log("EpayBGgetIDforPayment: ", validator.data.payment.ID)
      notifyEpayBgGetIdForPayment();
      return validator.data.payment.ID;
    });

  } catch (error) {
    console.log(error);
    notifyError();
  }
} */


/* const EpayBGMakePayment = async(APPID, DEVICEID, TOKEN, PINS, AMOUNT, DESCRIPTION, REASON, PAYMENT_ID, NAME) => {
  //THE AMOUNT HAS PROBLEM - IN FOODCHAIN WE GOT DECIMALS, IN EPAY 5.00 = 500!!!
  //console.log('EpayBGMakePayment: ', APPID, DEVICEID, TOKEN, PINS, AMOUNT, DESCRIPTION, REASON, PAYMENT_ID, NAME)
  let validators;
  try {
    validators = await Promise.all([
      axios.post('https://demo.epay.bg/xdev/api/payment/send/user', {
        APPID: APPID,
        DEVICEID: DEVICEID,
        TOKEN: TOKEN,
        PINS: PINS,
        AMOUNT: AMOUNT,
        DESCRIPTION: DESCRIPTION,
        RCPT: 8095111674,
        RCPT_TYPE: 'KIN',
        REASON: REASON,
        ID: PAYMENT_ID,
        SHOW: 'KIN',
        NAME: NAME
      })
    ]);

    return validators = validators.map(validator => {
      console.log("EpayBGMakePayment: ", validator.data);
      console.log('STATE.TEXT: ', validator.data.payment["STATE.TEXT"])
      notifyEpayBgPayment();
      return validator.data;
    });

  } catch (error) {
    console.log(error);
    notifyError();
  }
} */


/* const EpayBGCheckPayment = async(APPID, DEVICEID, TOKEN, PAYMENT_ID, id, products, user, cart, total, cb) => {
  let validators;
  try {
    validators = await Promise.all([
      axios.post('https://demo.epay.bg/xdev/api/payment/send/status', {
        APPID: APPID,
        DEVICEID: DEVICEID,
        TOKEN: TOKEN,
        ID: PAYMENT_ID,
      })
    ]);

    return validators = validators.map(validator => {
      console.log("EpayBGCheckPayment: ", validator.data)
      console.log('STATE.TEXT: ', validator.data.payment["STATE.TEXT"])
      console.log(typeof validator.data.payment["STATE.TEXT"])
      //validator.data.payment["STATE.TEXT"] === 'Извършено плащане' ? notifyEpayBgCheckPaymentDone() : notifyErrorDeclinedPayment()
      if(validator.data.payment["STATE.TEXT"] === 'Извършено плащане') {
        notifyEpayBgCheckPaymentDone()
        axios.post("https://api.dontwaste.me/orders/", {
            "account_id": id,
            "vendor_id": products[0].account_id,
            "created_by": user.nickname,
            "user_contacts": user.nickname,
            "inventories": cartQuantities(cart),
            "total_amount": total,
            "payment_method": "CARD",
            "user_notes": "WRONG some notes..."
            })
            .then(console.log('products: ', products, 'user: ', user, 'cart: ', parseInt(Object.values(cart.quantityById),0) ))
            .then(res => res.status === 201 ? (cb(), notifyOrderCreated(), sendOrderEmail(user, products, res.data.order.created)) : 'res.error')
            .catch(err => {
              console.log(err);
              notifyError()
            }); 
      } else {
        notifyErrorDeclinedPayment()
      }
      

      return validator.data;
    });

  } catch (error) {
    console.log(error);
    notifyError();
  }
  
} */

/* END OF EPAYBG FUNCTIONS */

const checkPayment = async(paymentID, user, id, products, cart, total, cb) => {
  //await axios.post("http://localhost:3004/payment/checkpayment", {
  await axios.post("https://api.dontwaste.me/orders/payment/checkpayment", {
    "paymentID": paymentID,
    "user": user
  })
  .then(res => 
    res.status === 200 ?
      res.data.epayCheckPayment[0].payment["STATE.TEXT"] === 'Извършено плащане' ?
        ( notifyEpayBgCheckPaymentDone(), makePayment(user, id, products, cart, total, cb) )
      : res.data.epayCheckPayment[0].payment["STATE.TEXT"] === 'Обработва се' ?
        notifyEpayBgCheckPayment()
        : notifyErrorDeclinedPayment()
    : res.error
    )
  .catch(err => {
    console.log(err);
    notifyError()
  });
}

const makePayment = async(user, id, products, cart, total, cb) => {
  axios.post("https://api.dontwaste.me/orders/", {
    "account_id": id,
    "vendor_id": products[0].account_id,
    "created_by": user.nickname,
    "user_contacts": user.nickname,
    "inventories": cartQuantities(cart),
    "total_amount": total,
    "payment_method": "CARD",
    "user_notes": "WRONG some notes..."
  })
  .then(console.log('products: ', products, 'user: ', user, 'cart: ', parseInt(Object.values(cart.quantityById),0) ))
  .then(res => res.status === 201 ? (cb(), notifyOrderCreated(), sendOrderEmail(user, products, res.data.order.created)) : 'res.error')
  .catch(err => {
    console.log(err);
    notifyError()
  });
}

/* const getTempTokenAuth0 = async() => {
  let validators;
  try {
    validators = await Promise.all([
      axios.post('https://fc-demo.eu.auth0.com/oauth/token', {
        "grant_type": "client_credentials",
        "client_id": "m9NKG7ybBVDkN8oDGn91gFZDAXXVjana",
        "client_secret": "LFTgAp7Zh7NfJNIy6rSoiTYGPbZXZeoiYy0M0M7srhe0KUvjbzI89HnFliFc_59f",
        "audience": "https://fc-demo.eu.auth0.com/api/v2/",
      })
    ]);

    return validators = validators.map(validator => {
      //console.log("getTempTokenAuth0: ", validator)
      return validator.data.access_token;
    });

  } catch (error) {
    console.log(error);
  }

} */

/* const checkAuth0UserTOKENfield = async(userid, Auth0token) => {
  let validators;
  try {
    validators = await Promise.all([
      axios.get(`https://fc-demo.eu.auth0.com/api/v2/users/${userid}`, {
        headers: {
          'Authorization': "Bearer " + Auth0token,
          'Content-Type': 'application/json',
        }
      })
    ]);

    return validators = validators.map(validator => {
      //console.log("checkAuth0UserTOKENfield: ", validator.data.app_metadata.TOKEN)
      return validator.data.app_metadata.TOKEN;
      //return validator.data.app_metadata;
    });

  } catch (error) {
    console.log(error);
  }

} */

//cb - callback - must be at the end of the call
const postOrder = async(products, user, cart, total, cartLocalStorage, totalLocalStorage, cb) => {
  console.log('Used payment provider:', cart.isCartPaid)
  //ALWAYS CHECK IF YOU HAVE SOMETHING IN THE LOCALSTORAGE BEFORE USING IT
  console.log('user', user)
  console.log('cart', cart)
  console.log('total', total)
  console.log('cartLocalStorage', cartLocalStorage)
  console.log('totalLocalStorage', totalLocalStorage)
  //TO MAKE THIS FUCNTION DUMMY, JUST COMMENT EVERYTHING WITHOUT THE cb()
  //cb()
  console.log('products: ',products);
  //console.log('products[0].account_id: ', products[0].account_id);
  //console.log('cb: ',cb);
  //console.log('inv mapped', cartQuantities(cart));
  //TOTAL IS WRONG!!! IF TOTAL IS 5.00, EPAY SEND 500!!! ASK EPAY SUPPORT
  //console.log('total= ', total);
  //console.log('total/100= ', total/100);
  //const APPID = '2123128777047314469988321512492541281777074012414332339158786136';
  //const auth0TempToken = await getTempTokenAuth0();
  //console.log('auth0TempToken ', auth0TempToken)
  //const checkAuth0UserTokenFiled = await checkAuth0UserTOKENfield(user.id, auth0TempToken[0]);
  //console.log('checkAuth0UserTokenFiled ', checkAuth0UserTokenFiled)
  //const DEVICEID = 'google-oauth2%7C106229277036146591397';
  //const DEVICEID = user.id;
  //console.log('DEVICEID ',DEVICEID)
  //const TOKEN = '26051567688179934894851805989213';
  //const TOKEN = checkAuth0UserTokenFiled[0];

  const findPipe = user.sub.indexOf("|");
  const id = user.sub.substr(findPipe+1);

  //console.log('APPID, DEVICEID, TOKEN: ', APPID, DEVICEID, TOKEN)
  //const epayUserInfo = await EpayBGgetUserInfo(APPID, DEVICEID, TOKEN);
  //console.log('epayUserInfo[0].ID', epayUserInfo[0].ID)
  //const epayIdPayment = await EpayBGgetIDforPayment(APPID, DEVICEID, TOKEN);
  //console.log('epayIdPayment[0]: ', epayIdPayment[0]);
  /* const epayMakePayment = await EpayBGMakePayment(
    APPID, 
    DEVICEID, 
    TOKEN,
    epayUserInfo[0].ID, 
    total/100, 
    cartQuantities(cart), 
    `Buy food from ${products[0].account_id}`, 
    epayIdPayment[0], 
    epayUserInfo[0].NAME
  ); */
  //console.log('epayMakePayment', epayMakePayment)
  //console.log('epayMakePayment[0].payment.ID: ', epayMakePayment[0].payment.ID)
  //const epayCheckPayment = await EpayBGCheckPayment(APPID, DEVICEID, TOKEN, epayMakePayment[0].payment.ID);
  //console.log('epayCheckPayment', epayCheckPayment)
  //wait 10 seconds then check the PAYMENT
  if(cart.isCartPaid === 'yesByStripe') {
    console.log('Stripe payment -> order will be created automatically...')
    if(Object.keys(cart.quantityById).length > 0 && total > 0) {
        console.log('stripe if')
        try {
          await axios.post("https://api.dontwaste.me/orders/", {
            "account_id": id,
            "created_by": user.nickname,
            "vendor_id": cart.addedIds_placeIds[0],
            "user_contacts": user.email,
            "inventories": cartQuantities(cart),
            "total_amount": total
          }).then(
            res => {
              if (res.status === 201) {
                console.log("orderid", res.data.order._id)
                cb()
                notifyOrderCreated()
                sendOrderEmail(user, products, res.data.order.created)
              } else {
                notifyError()
              }
            }
          )
        } catch (err) {
            console.log(err);
            notifyError()
        }
    } else {
        console.log('stripe else')
        await axios.post("https://api.dontwaste.me/orders/", {
          "account_id": id,
          "created_by": user.nickname,
          "vendor_id": cartLocalStorage.addedIds_placeIds[0],
          "user_contacts": user.email,
          "inventories": cartQuantities(cartLocalStorage),
          "total_amount": totalLocalStorage
        }).then(
          res => {
            if (res.status === 201) {
              console.log("orderid", res.data.order._id)
              cb()
              notifyOrderCreated()
              sendOrderEmail(user, cartQuantities(cartLocalStorage), res.data.order.created)
            }
          }
        ).catch(err => {
          console.log(err);
          notifyError()
        });
    }
  } else {
      if(Object.keys(cart.quantityById).length > 0 && total > 0) {
        await axios.post("https://api.dontwaste.me/orders/payment/makepayment", {
        "user": user,
        "total": total,
        "cart": cartQuantities(cart),
        "reason": `Buy food from ${products[0].account_id}`,
        })
        .then(res => res.status === 200 && res.data.epayMakePayment[0].status !== 'ERR' ? ( notifyEpayBgPayment(), notifyEpayBgCheckPayment(), setTimeout(() => { checkPayment(res.data.epayMakePayment[0].payment.ID, user, id, products, cart, total, cb) }, 5000 ) ) : res.error)
        .catch(err => {
          console.log(err);
          notifyError()
        });
    } else {
      await axios.post("https://api.dontwaste.me/orders/payment/makepayment", {
        "user": user,
        "total": totalLocalStorage,
        "cart": cartQuantities(cartLocalStorage),
        "reason": `Buy food from ${cartLocalStorage.addedIds_placeIds[0]} after browser REFRESH`,
        })
        .then(res => res.status === 200 ? ( console.log('else res ', res), notifyEpayBgPayment(), notifyEpayBgCheckPayment(), setTimeout(() => { checkPayment(res.data.epayMakePayment[0].payment.ID, user, id, cartLocalStorage.addedIds_placeIds[0], cartLocalStorage, totalLocalStorage, cb) }, 5000 ) ) : res.error)
        .catch(err => {
          console.log(err);
          notifyError()
        });
    }
  }
  

  //await axios.post("http://localhost:3004/payment/makepayment", {
  /* await axios.post("https://api.dontwaste.me/orders/payment/makepayment", {
    "user": user,
    "total": total,
    "cart": cartQuantities(cart),
    "reason": `Buy food from ${products[0].account_id}`,
  })
  .then(res => res.status === 200 ? ( notifyEpayBgPayment(), notifyEpayBgCheckPayment(), setTimeout(() => { checkPayment(res.data.epayMakePayment[0].payment.ID, user, id, products, cart, total, cb) }, 5000 ) ) : res.error)
  .catch(err => {
    console.log(err);
    notifyError()
  }); */
  

  //notifyEpayBgCheckPayment();
  //const epayCheckPayment = setTimeout(() => { EpayBGCheckPayment(APPID, DEVICEID, TOKEN, epayMakePayment[0].payment.ID, id, products, user, cart, total, cb); }, 5000);
  //const epayCheckPayment = await EpayBGCheckPayment(APPID, DEVICEID, TOKEN, epayMakePayment[0].payment.ID);
  //const epayCheckPaymentTime = setTimeout(() => { console.log('5 sec'); }, 5000);
  //console.log('epayCheckPayment', epayCheckPayment)
  
  //epayCheckPayment.data.payment["STATE.TEXT"] === 'Извършено плащане' ? notifyEpayBgCheckPaymentDone() : notifyErrorDeclinedPayment()
  //console.log(typeof epayCheckPayment)

  /* await axios.post("https://api.dontwaste.me/orders/", {
      "account_id": id,
      "vendor_id": products[0].account_id,
      "created_by": user.nickname,
      "user_contacts": user.nickname,
      "inventories": cartQuantities(cart),
      "total_amount": total,
      "payment_method": "CARD",
      "user_notes": "WRONG some notes..."
  })
  .then(console.log('products: ', products, 'user: ', user, 'cart: ', parseInt(Object.values(cart.quantityById),0) ))
  .then(res => res.status === 201 ? (cb(), notifyOrderCreated(), sendOrderEmail(user, products, res.data.order.created)) : 'res.error')
  .catch(err => {
    console.log(err);
    notifyError()
  }); */
};

const sendOrderEmail = async(user, products, created) => {
  console.log('sendOrderEmail products ', products)
  const findPipe = user.sub.indexOf("|");
  const id = user.sub.substr(findPipe+1);
  await axios.post("https://api.dontwaste.me/email/smtp/order_created", {
      "from_id": id,
      "to_id": products[0].account_id,
      "products": {...products},
      "created": created
    }
  )
};

/* 
await axios.post("http://139.59.205.81/orders/", {
      "account_id": "5c891024ba001f00067381e8",
      "created_by": "pepo9",
      "contact": "User Nickname or Name",
      "inventory": {
        "_id": "5dc52d0658e0806eab4446ad",
        "account_id": "5c891024ba001f00067381e8",
        "place_id": "5d877978832f356ffb03512e",
        "product_id": "5dc400aff88830515dc9fe0d",
        "quantity_available": 2,
        "original_price": 8,
        "reduced_price": 2,
        "expiry_date": "1573484118334000",
        "created": "1573203206",
        "__v": 0
      },
    "quantity": 2
  })
*/

export default {
  postOrder
};
